var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "d8a385b57461500a4cb96c0d3284aa7e.png",
    width: 60,
    height: 61
});